var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useLayoutEffect, useRef, useState } from "react";
import "./styles.scss";
import { throttle } from "throttle-debounce";
var Truncate = function (_a) {
    var height = _a.height, children = _a.children;
    var ref = useRef(null);
    var _b = __read(useState(0), 2), cachedHeight = _b[0], setCachedHeight = _b[1];
    var _c = __read(useState("auto"), 2), width = _c[0], setWidth = _c[1];
    var onResize = useCallback(function () {
        var _a;
        var refWidth = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        setWidth(refWidth ? refWidth + "px" : "auto");
    }, [ref]);
    useLayoutEffect(function () {
        onResize();
        var resizeHandler = throttle(1000, onResize);
        window.addEventListener("resize", resizeHandler);
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !height)
            setCachedHeight(ref.current.clientHeight);
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && height)
            setCachedHeight(height);
        return function () { return window.removeEventListener("resize", resizeHandler); };
    }, [onResize]);
    return (_jsx("div", __assign({ className: "truncate", ref: ref, style: __assign({}, (cachedHeight && {
            height: cachedHeight + "px",
        })) }, { children: _jsx("span", __assign({ className: "truncate__item", style: __assign({ maxWidth: width }, (cachedHeight && {
                position: "absolute",
            })) }, { children: children }), void 0) }), void 0));
};
export { Truncate };
